<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-card :loading="Object.keys(privs).length == 0">
				<v-card-text>
					<v-form v-if="privs['new']" v-model="valid">
						<v-row>
							<v-col cols="12" md="6" class="pa-2">
								<v-text-field
									v-model="newCommunication.communicationTypeID"
									outlined
									hide-details="auto"
									label="معرف وسيلة الاتصال"
									dir="ltr"
									:rules="[rules.required, rules.id]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="pa-2">
								<v-text-field
									v-model="newCommunication.name"
									outlined
									hide-details="auto"
									label="اسم وسيلة الإتصال"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="pa-2">
								<v-text-field
									v-model.trim="newCommunication.logo"
									outlined
									hide-details="auto"
									label="رابط صورة العرض"
									dir="ltr"
									:rules="[rules.required, rules.link]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="pa-2">
								<v-text-field
									v-model="newCommunication.description"
									outlined
									hide-details="auto"
									label="الوصف"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="pa-2">
								<v-text-field
									v-model="newCommunication.websiteLink"
									outlined
									hide-details="auto"
									label="موقع وسيلة الاتصال"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="pa-2">
								<v-text-field
									v-model="newCommunication.initialProfilesPath"
									outlined
									hide-details="auto"
									label="البادئة"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="pa-2 text-center">
								<v-btn
									color="success"
									:loading="loading"
									:disabled="!valid"
									@click="addContact"
								>
									إضافة
									<v-icon right>mdi-plus</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-form>

					<v-row>
						<v-col cols="12" class="pa-2">
							<v-data-table hide-default-footer :headers="headers" :items="communications" :items-per-page="-1">
									<template #[`item.name`]="{ item }">
										<div v-if="item.isEdit">
											<v-form v-model="item.valid">
												<v-text-field v-model="item.name" :disabled="item.isLoading" :rules="[rules.required]"></v-text-field>
											</v-form>
										</div>
										<div v-else>{{ item.name }}</div>
									</template>

									<template #[`item.websiteLink`]="{ item }">
										<div v-if="item.isEdit">
											<v-form v-model="item.valid">
												<v-text-field v-model.trim="item.websiteLink" :disabled="item.isLoading" :rules="[rules.required, rules.link]"></v-text-field>
											</v-form>
										</div>
										<div v-else>{{ item.websiteLink }}</div>
									</template>

									<template #[`item.logo`]="{ item }">
										<div v-if="item.isEdit">
											<v-form v-model="item.valid">
												<v-text-field v-model.trim="item.logo" :disabled="item.isLoading" dir="ltr" :rules="[rules.required, rules.link]"></v-text-field>
											</v-form>
										</div>
										<div v-else>{{ item.logo }}</div>
									</template>

									<template #[`item.description`]="{ item }">
										<div v-if="item.isEdit">
											<v-text-field v-model="item.description" :disabled="item.isLoading"></v-text-field>
										</div>
										<div v-else>{{ item.description }}</div>
									</template>

									<template #[`item.initialProfilesPath`]="{ item }">
										<div v-if="item.isEdit">
											<v-text-field v-model="item.initialProfilesPath" :disabled="item.isLoading"></v-text-field>
										</div>
										<div v-else>{{ item.initialProfilesPath }}</div>
									</template>

									<template #[`item.actions`]="{ item }">
										<v-form v-model="item.valid">
											<v-tooltip v-if="item.isEdit == false" bottom>
												<template #activator=" {on} ">
													<v-btn icon medium :disabled="!privs['manage'] || item.isLoading" v-on="on" @click="enableEditCommunication(item)">
														<v-icon color="primary">mdi-comment-edit</v-icon>
													</v-btn>
												</template>
												<span>تحرير</span>
											</v-tooltip>

											<v-tooltip v-else bottom>
												<template #activator=" {on} ">
													<v-btn icon medium :disabled="item.isLoading || !item.valid" v-on="on" @click="enableEditCommunication(item)">
														<v-icon color="success">mdi-comment-check</v-icon>
													</v-btn>
												</template>
												<span>حفظ</span>
											</v-tooltip>
										</v-form>

										<v-tooltip bottom>
											<template #activator="{ on }">
												<v-btn
													:disabled="!privs['delete'] || item.isLoading"
													icon
													color="error"
													v-on="on"
													@click="confirmDeleteCommunication(item)"
												>
													<v-icon>mdi-delete</v-icon>
												</v-btn>
											</template>

											<span>حذف</span>
										</v-tooltip>
									</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>

			<app-confirmation-dialog ref="confirm"></app-confirmation-dialog>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	components:{
		AppConfirmationDialog: () => import(/* webpackChunkName: "app-confirmation-dialog" */ "@/components/AppConfirmationDialog"),
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					disabled: false,
					to: { name: "dashboard-home" }
				},
				{ 
					text: "أنواع وسائل التواصل",
					disabled: true 
				}
			],
			loading: true,
			communications: [],
			valid: false,

			headers: [
				{ value: "communicationTypeID", text: "معرف الاتصال" },
				{ value: "name", text: "اسم نوع الإتصال" },
				{ value: "description", text: "الوصف" },
				{ value: "logo", text: "الصورة" },
				{ value: "websiteLink", text: "الموقع" },
				{ value: "initialProfilesPath", text: "البادئة" },
				{ value: "actions", text: "عمليات", align: "end" }
			],
			newCommunication: {
				communicationTypeID: "",
				name: "",
				description: "",
				logo: "",
				websiteLink: "",
				initialProfilesPath: "",
			},
		};
	},
	mounted() {
		this.getPrivileges();
		this.getCommunications();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/commTypeIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCommunications() {
			client
				.get("/api/communication/types")
				.then(response => {
					this.communications = response.data.map(communication => {
						communication.isEdit = false;
						communication.valid = false;
						return communication
					});
					this.loading = false;
				})
		},
		enableEditCommunication(item) {
			if(item.isEdit) {
				this.updateInfo(item)
			} else {
				item.isEdit = true;
			}
		},
		updateInfo(item){
			item.isLoading = true;

			clientNotifier
				.post("/api/communication/updateType", item)
				.then(() => {
					item.isEdit = false;
				})
				.finally(() => {
					item.isLoading = false;
				});
		},
		addContact(){
			this.loading = true;

			clientNotifier
				.post("/api/communication/newType", this.newCommunication)
				.then(response => {
					this.communications.push({
						...response.data.data,
						isEdit: false
					})
				})
				.catch(err => {
					console.log(err);
				})
				.finally(()=>{
					this.loading = false;
				})
		},
		async confirmDeleteCommunication(item) {
			const confirmed = await this.$refs.confirm.open({ title: "تأكيد الحذف",  message: "هل تريد حقاً حذف هذه الوسيلة" });
			if (confirmed) { this.deleteCommunication(item); }
		},
		deleteCommunication(item) {
			item.isLoading = true;

			clientNotifier
				.delete("/api/communication/deleteType/" + item.communicationTypeID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					this.getCommunications();
					console.log(response);
				})
				.catch(err => {
					console.log(err);
					item.isLoading = false;
				});
		},
	}
};
</script>